import Login from '../pages/auth/connexion';
import MotDePasseOublie from '../pages/auth/MotDePasseOublie';
import ResetPassword from '../pages/auth/ResetPassword';
import ResetPasswordConfirm from '../pages/auth/ResetPasswordConfirm';
import ParticipationPage from '../pages/participant/ParticipationPage';
import Unauthorized from '../pages/Unauthorized';
import NotFound from '../pages/NotFound';
import RegisterAdmin from '../pages/auth/RegisterAdmin';
import ActivateAccount from '../pages/auth/ActivateAccount';
import SSOCallback from '../pages/auth/SSOCallback';
import {ROUTES} from '../constants/routes';

/**
 * Routes publiques - accessibles sans authentification
 */
export const publicRoutes = [
  { path: ROUTES.LOGIN, element: <Login /> },
  { path: '/inscription-admin', element: <RegisterAdmin /> },
  { path: '/activate', element: <ActivateAccount /> },
  { path: ROUTES.PASSWORD_RESET_REQUEST, element: <MotDePasseOublie /> },
  { path: ROUTES.PASSWORD_RESET, element: <ResetPassword /> },
  { path: ROUTES.PASSWORD_RESET_CONFIRM, element: <ResetPasswordConfirm /> },
  { path: ROUTES.PUBLIC_PARTICIPATION, element: <ParticipationPage /> },
  // ✅ NOUVEAU : Route SSO Callback
  { path: ROUTES.SSO_CALLBACK, element: <SSOCallback /> },
  { path: '/non-autorise', element: <Unauthorized /> },
  { path: '/not-found', element: <NotFound /> },
];